import { render, staticRenderFns } from "./PersonalStudent.vue?vue&type=template&id=426cf02e"
import script from "./PersonalStudent.vue?vue&type=script&lang=js"
export * from "./PersonalStudent.vue?vue&type=script&lang=js"
import style0 from "./PersonalStudent.vue?vue&type=style&index=0&id=426cf02e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports